<div class="mt-4">

  <app-stepper
    [step]="1"
  ></app-stepper>
  <h2 class="mt-5 mt-lg-6 fw-bold" *ngIf="!loadingRedirect">
    {{ project.name }}
  </h2>
  <div class="lead" *ngIf="!loadingRedirect">
    {{ 'StepLeadGeneration.Title' | translate }}
  </div>
  <form [formGroup]="dynamicFormGroup">
    <!-- STEP 1 / Email Information -->
    <ng-container *ngIf="showFirstSection">
      <app-form-input-text
        [type]="'email'"
        [placeholder]="'General.Email' | translate"
        [required]="true"
        [name]="'Email'"
        [valid]="emailValid"
        [label]="'General.Email' | translate"
        (onValueChanged)="onValueChanged($event, 'Email')"
        [formName]="dynamicFormGroup"
        [control]="getFormControl('Email')"
      >
      </app-form-input-text>
      <app-form-input-text
        [type]="'email'"
        [placeholder]="'General.EmailConfirmation' | translate"
        [label]="'General.EmailConfirmation' | translate"
        [required]="true"
        [name]="'EmailConfirmation'"
        [valid]="emailVerificationValid"
        (onValueChanged)="onValueChanged($event, 'EmailConfirmation')"
        [formName]="dynamicFormGroup"
        [control]="getFormControl('EmailConfirmation')"
      >
      </app-form-input-text>
      <div class="mt-4 text-end">
        <app-form-button-submit
          [name]="'nextLayer'"
          [active]="isSubmitPart1ButtonActive()"
          [label]="'General.ButtonContinue' | translate"
          [icon]="'angle-right'"
          [error]="firstSectionShowErrorSubmitButton"
          [errorMessage]="firstSectionErrorMessage"
          (onClicked)="onSubmitPart1($event)"
        ></app-form-button-submit>
      </div>
    </ng-container>

    <!-- STEP 1.1 / Personal details -->
    <ng-container *ngIf="showSecondSection">
      <div *ngIf="isEmailAlreadyRegistered" class="alert alert-info mb-4">
        <div class="d-flex align-items-center">
          <i class="fa-solid fa-circle-info me-2"></i>
          <span>{{ 'General.ErrorAlreadyRegistered' | translate }}: {{ dynamicFormGroup.get('Email')?.value }}</span>
        </div>
      </div>
      <div class="">
        <app-form-input-dropdown
          [values]="salutationValues"
          [type]="'Standard'"
          [selectedValue]="dynamicFormGroup.get('Salutation')?.value"
          [label]="'StepLeadGeneration.Salutation' | translate"
          [formName]="dynamicFormGroup"
          [control]="getFormControl('Salutation')"
          [placeholder]="'General.InputSelectPlaceholder' | translate"
        ></app-form-input-dropdown>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <app-form-input-text
              [type]="'text'"
              [placeholder]="'StepLeadGeneration.FirstName' | translate"
              [label]="'StepLeadGeneration.FirstName' | translate"
              [required]="true"
              [name]="'FirstName'"
              [autocomplete]="'on'"
              (onValueChanged)="$event"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('FirstName')"
            ></app-form-input-text>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <app-form-input-text
              [type]="'text'"
              [placeholder]="'StepLeadGeneration.LastName' | translate"
              [label]="'StepLeadGeneration.LastName' | translate"
              [required]="true"
              [name]="'LastName'"
              [autocomplete]="'on'"
              (onValueChanged)="$event"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('LastName')"
            ></app-form-input-text>
          </div>
        </div>
        <div *ngIf="enableAddress" class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4">
            <app-form-input-text
              [type]="'text'"
              [placeholder]="'StepLeadGeneration.Street' | translate"
              [label]="'StepLeadGeneration.Street' | translate"
              [required]="true"
              [name]="'Street'"
              [autocomplete]="'on'"
              (onValueChanged)="$event"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('Street')"
            ></app-form-input-text>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4">
            <app-form-input-text
              [type]="'text'"
              [placeholder]="'StepLeadGeneration.Location' | translate"
              [label]="'StepLeadGeneration.Location' | translate"
              [required]="true"
              [name]="'Location'"
              [autocomplete]="'on'"
              (onValueChanged)="$event"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('Location')"
            ></app-form-input-text>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4">
            <app-form-input-text
              [type]="'text'"
              [placeholder]="'StepLeadGeneration.Zip' | translate"
              [label]="'StepLeadGeneration.Zip' | translate"
              [required]="true"
              [name]="'Zip'"
              [autocomplete]="'on'"
              (onValueChanged)="$event"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('Zip')"
            ></app-form-input-text>
          </div>
        
        </div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4">
            <app-form-input-dropdown
              [values]="telPrefixes"
              [type]="'TelPrefix'"
              [label]="'StepLeadGeneration.TelephonePrefix' | translate"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('PhoneNumberPrefix')"
            ></app-form-input-dropdown>
          </div>
          <div class="col">
            <app-form-input-text
              [type]="'number'"
              [placeholder]="'StepLeadGeneration.TelephoneNumber' |translate"
              [label]="'StepLeadGeneration.TelephoneNumber' | translate"
              [required]="true"
              [name]="'phoneNumber'"
              [autocomplete]="'off'"
              (onValueChanged)="$event"
              [toolTipMessage]="'StepLeadGeneration.TelephoneNumberToolTip' | translate"
              [formName]="dynamicFormGroup"
              [control]="getFormControl('phoneNumber')"
            ></app-form-input-text>
          </div>
        </div>
        <div class="mt-4 mt-lg-5">
          <app-form-input-checkbox
            [name]="'TOS'"
            [label]="'StepLeadGeneration.TOS' | translate"
            [required]="true"
            [formName]="dynamicFormGroup"
            [control]="dynamicFormGroup.controls['TOS']"
            (onValueChanged)="onValueChanged($event, 'TOS')"
          >
          </app-form-input-checkbox>
        </div>
        <div class="mt-4" *ngIf="isSendSmsEnabled">
          <app-form-input-checkbox
            [name]="'SendSms'"
            [label]="'StepLeadGeneration.SendSms' | translate"
            [required]="false"
            [formName]="dynamicFormGroup"
            [control]="dynamicFormGroup.get('SendSms')"
            (onValueChanged)="onValueChanged($event, 'SendSms')"
          >
          </app-form-input-checkbox>
        </div>
        <div class="mt-5 d-xxl-flex btn-group-before-xxl justify-content-xxl-between">

          <button class="btn btn-lg mb-3 mb-xxl-0 btn-light w-100 w-xxl-auto"
                  (click)="clickOnBackButton()"
          ><i class="pe-2 fa-solid fa-angle-left"></i>{{'General.ButtonBack' | translate }}
          </button>

          <app-form-button-submit
            [name]="'nextLayer'"
            [active]="dynamicFormGroup.valid"
            [class]="'w-100 mt-3 mt-xxl-0 w-xxl-auto'"
            [icon]="'paper-plane'"
            [label]="'General.ButtonSubmit' | translate"
            (click)="onClickSubmitLeadGeneration(); getFormValidationErrors()"
          ></app-form-button-submit>

        </div>
      </div>
    </ng-container>
  </form>
  <ng-container *ngIf="loadingRedirect">
    <app-spinner></app-spinner>
  </ng-container>
</div>
